import request from '@/utils/request'
import qs from 'qs'

// 提交报销数据
export function addApplyExpense(params) {
    return request({
        url: '/crm/ApplyExpense/addApplyExpense',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 获取报销事项列表
export function getApplyItemList(params) {
    return request({
        url: '/crm/Mymine/getApplyItemList',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 报销详情
export function applyExpenseListOne(params) {
    return request({
        url: '/crm/ApplyExpense/applyExpenseListOne',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 修改报销数据
export function editApplyExpense(params) {
    return request({
        url: '/crm/ApplyExpense/editApplyExpense',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 删除已经作废的报销
export function delApplyExpense(params) {
    return request({
        url: '/crm/ApplyExpense/delApplyExpense',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 报销详情页面的审批流程
export function getExamineUserPcApply(params) {
    return request({
        url: '/crm/Mymine/getExamineUserPcApply',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// 待我审批报销 列表
export function waitApply(params) {
    return request({
        url: '/crm/Mymine/waitApply',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 审批报销接口
export function examinePortApply(params) {
    return request({
        url: '/crm/Mymine/examinePortApply',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 我的审批报销 列表接口
export function alreadyApply(params) {
    return request({
        url: '/crm/Mymine/alreadyApply',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// 我的审批报销 列表接口
export function getExamineRecordApply(params) {
    return request({
        url: '/crm/Mymine/getExamineRecordApply',
        method: 'POST',
        data: qs.stringify(params)
    })
}
